module.exports = __webpack_public_path__ + "img/standardOA.0a0b0c62.png";